package com.schoolconnect.app.feature.schools.details

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.schoolconnect.app.feature.schools.SchoolRowUi

@Composable
fun SchoolDetailsFeatureRoute(
    school: SchoolRowUi? = null,
    onBack: () -> Unit
) {
    val viewModel = remember(school) { SchoolDetailsViewModel(school) }
    val uiState by viewModel.uiState.collectAsState()

    DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }

    SchoolDetailsScreen(
        state = uiState,
        onEvent = viewModel::onEvent,
        onBack = onBack
    )
}
